import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppContext } from '../../appprovider';
import DemoLockedDialog from './DemoLockedDialog';
import { isFeatureDisabled, isFeatureHidden } from '../services/demoPolicy';

const PORTAL_HOME = '/Portal/Instructor';

/**
 * Redirects hidden demo sections and shows a dialog when a disabled section is opened directly.
 */
export function DemoAccessGate({ featureKey, children }) {
  const { entitlements } = useAppContext();
  const [dialogOpen, setDialogOpen] = useState(false);

  const hidden = isFeatureHidden(entitlements, featureKey);
  const disabled = isFeatureDisabled(entitlements, featureKey);

  useEffect(() => {
    if (disabled) {
      setDialogOpen(true);
    }
  }, [disabled]);

  if (hidden) {
    return <Navigate to={PORTAL_HOME} replace />;
  }

  if (disabled) {
    return (
      <>
        <Navigate to={PORTAL_HOME} replace />
        <DemoLockedDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
      </>
    );
  }

  return children;
}
